import { api } from '../core';
import { setDocument } from '@/store/slices/gdpr/documents';
import { GDPR_DOCUMENT_TAG } from '../constants';

export interface MetaData {
  aiChecked: boolean;
  caseId: string;
  documentName: string;
  caseReference: string;
}

export interface PageDimension {
  width: number;
  height: number;
}

export interface Page {
  id: string;
  originalPageNumber: number;
  customOrdering: number;
  pageDimensions: PageDimension;
  pageUri: string;
  detectedBlank: boolean;
  detectedBreach: boolean;
  confirmedBlank: boolean;
  confirmedBreach: boolean;
}

export interface GetDocumentResponse {
  metadata: MetaData;
  pages: Record<string, Page>;
}

export interface SortedDocumentResponse {
  metadata: MetaData;
  pages: Page[];
}

export interface GetDocumentProps {
  document_id: string;
}

const getGDPRDocumentApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getDocument: builder.query<GetDocumentResponse, GetDocumentProps>({
      query: ({ document_id }: GetDocumentProps) => {
        return {
          url: `document?document_id=${document_id}`,
          method: 'GET'
        };
      },
      providesTags: (_result, _err, { document_id }) => [{ type: GDPR_DOCUMENT_TAG, id: document_id }],
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;

          // Sort pages by customOrdering before storing
          const sortedPagesArray = Object.entries(data.pages)
            .map(([id, page]) => ({ ...page, id }))
            .sort((a, b) => a.customOrdering - b.customOrdering);

          const sortedData: SortedDocumentResponse = {
            ...data,
            pages: sortedPagesArray // Store as array
          };

          // Dispatch the sorted document data to Redux slice
          dispatch(setDocument(sortedData));
        } catch (error) {
          console.error('GDPR API - Failed to fetch GDPR document:', error);
        }
      }
    })
  })
});

export const { useGetDocumentQuery, useLazyGetDocumentQuery } = getGDPRDocumentApi;
